export default "__VITE_ASSET__05BKuuub__"